import {
	FREE_PLAN_LIMIT_CLUB_ADD_ON_NUM_NODES_LIMIT,
	RUNNITS_OWNER_SELECTION,
	TEAM_BOARD_LIMIT_NUM_NODES_LIMIT,
} from '@/views/Runnits/constants';

// Team boards use the team limit; personal boards use the plan's limit (clubInfo.limit.numNodesLimit)
export const getRunnitNumNodesLimit = (runnitsOwnerSelection: string, planNumNodesLimit: number | undefined): number => {
	if (runnitsOwnerSelection === RUNNITS_OWNER_SELECTION.TEAM) {
		// DEPRECATED - Please stop supporting this soon when we have team Runnit subscriptions done
		return TEAM_BOARD_LIMIT_NUM_NODES_LIMIT;
	}
	return planNumNodesLimit || FREE_PLAN_LIMIT_CLUB_ADD_ON_NUM_NODES_LIMIT;
};

export const isAtRunnitNodesLimit = (numNodes: number, numNodesLimit: number): boolean => numNodes >= numNodesLimit;
